import './utility/IPAddress'

window.initFormyChatDropDown = () => {

    const target = document.querySelector('.formychat-dropdown')
    if (!target) return

    /* These lines of code are selecting specific elements within the `.formychat-dropdown` element.
    Here is what each line is doing: */
    const placeholder = target.querySelector('.formychat-dropdown-placeholder')
    const search = target.querySelector('.formychat-dropdown-content-search')
    const input = target.querySelector('.formychat-dropdown-input')

    /**
     * The `registerEvents` function in JavaScript sets up event listeners for click, keyup, and custom
     * events to handle interactions with a dropdown component.
     */
    const registerEvents = () => {

        // On Click 
        document.addEventListener('click', (e) => {

            // on clicked placeholder.
            if (e.target.closest('.formychat-dropdown-placeholder')) {
                return toggle(e)
            }

            if (!e.target.closest('.formychat-dropdown') && !e.target.closest('.formychat-dropdown-placeholder')) {
                return close()
            }
            // on clicked item
            if (e.target.closest('.formychat-dropdown-content-item') || e.target.classList.contains('formychat-dropdown-content-item')) {
                return choose(e)
            }
        })
        // Keypress.
        document.addEventListener('keyup', (e) => {
            // Ba if target not match the dropdown, return.
            if (!e.target.closest('.formychat-dropdown')) return

            // On search input
            if (e.target.closest('.formychat-dropdown-content-search')) {
                // console.log('search', e.target.value.toLowerCase().trim());
                update(e.target.value.toLowerCase().trim())
                return
            }

            // ESC key
            if (e.key === 'Escape') {
                close()
                return
            }
        })

        // Choose default item.
        const defaultItem = target.querySelector('.formychat-dropdown-content-item.selected')
        if (defaultItem) {
            choose({ target: defaultItem })
        }
    }

    window.addEventListener('DOMContentLoaded', registerEvents)

    // toggle the dropdown.
    const toggle = (e) => {
        e.preventDefault()
        e.stopPropagation()


        if (target.classList.contains('open')) {
            close()
            return
        }
        open()
    }


    /**
     * The `open` function adds the 'active' class to a target element, focuses on a search input, and
     * scrolls to a selected item within the target element if it exists.
     */
    const open = () => {
        target.classList.add('active')
        
        // Focus on search input.
        search.focus()

        // Scroll to selected item.
        const selected = target.querySelector('.formychat-dropdown-content-item.selected')
        if (selected) {
            selected.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }
    }


    /**
     * The function `close` removes the 'active' class from the target element.
     */
    const close = () => {

        // console.log('closing');
        target.classList.remove('active')
    }

    // Choose the item.
    /**
     * The `choose` function selects an item from a dropdown menu, updates placeholder text, hidden
     * input value, resets search, and closes the dropdown.
     * @param e - The `e` parameter in the `choose` function is typically an event object that
     * represents the event that triggered the function. It could be a click event, keypress event,
     * etc. This parameter is used to access information about the event, such as the target element
     * that was clicked or interacted
     */
    const choose = (e) => {
        // Unselect all items
        const items = target.querySelectorAll('.formychat-dropdown-content-item')
        items.forEach(i => {
            i.classList.remove('selected')
        })

        // Select clicked item
        e.target.classList.add('selected')

        // Update placeholder
        if (placeholder) {
            placeholder.querySelector('span').textContent = e.target.dataset.placeholder
        }

        // Update hidden input value
        input.value = e.target.dataset.value

        // Reset search.
        search.value = ''
        update()
        close()
    }

    // Update the items.
    /**
     * The `update` function filters and displays elements based on a search string.
     * @param [s] - The `s` parameter in the `update` function is a string that is used to filter the
     * items displayed on the webpage. The function iterates over a list of items with the class name
     * `.formychat-dropdown-content-item` and checks if the `dataset.tags` attribute of each item
     * includes
     */
    const update = (s = '') => {
        const items = target.querySelectorAll('.formychat-dropdown-content-item')
        items.forEach(i => {

            let display = !s || s.length === 0

            if (s && s.length) {
                display = s.length === 0 || i.dataset.tags.toLowerCase().includes(s)
            }

            i.style.display = display ? 'block' : 'none'
        })
    }

    // If the value is empty, set window.formychat_country_code.
    if (!input.value || input.value.length === 0) {
       
        // Wait for country code to be available
        if (window.formychat_country_code) {
            
            // Find item with matching country code
            const items = target.querySelectorAll('.formychat-dropdown-content-item');
            const defaultItem = Array.from(items).find(item =>
                item.dataset.value === window.formychat_country_code
            );

            // If found matching item, select it
            if (defaultItem) {
                /* The line `choose({ target: defaultItem });` is calling the `choose` function with an
                object as an argument. The `target` property of the object is set to the
                `defaultItem` element. */
                choose({ target: defaultItem });
            }
        } else {
            // Listen for country code event if not yet available
            window.addEventListener('formychat_ip_loaded', (e) => {
                const countryCode = e.detail?.country_phone?.replace('+', '') || '44';
                const items = target.querySelectorAll('.formychat-dropdown-content-item');
                const defaultItem = Array.from(items).find(item =>
                    item.dataset.value === countryCode
                );

                if (defaultItem) {
                    choose({ target: defaultItem });
                }
            });
        }
    } else {

        let item = target.querySelector('.formychat-dropdown-content-item[data-value="' + input.value + '"]')
        if (item) {
            choose({ target: item })
        }
    }

    // Trigger the event.
    window.dispatchEvent(new Event('formychat_dropdown_initialized'))
    

}

document.addEventListener('DOMContentLoaded', initFormyChatDropDown)
 
// Contact Form 7 Routing.
const contactForm7Routing = () => {
    // If the page is a CF7 page (?page=wpcf7), and #formychat is in the url, then redirect to the formychat page.
    if (window.location.href.includes('page=wpcf7') && window.location.hash === '#formychat') {
        // Find #formychat-tab and click.
        const formychat = document.querySelector('#formychat-tab')
        if (formychat) {
            formychat.click()
        }
    }
}
document.addEventListener('DOMContentLoaded', contactForm7Routing)


// On Ninja Form admin page.
const ninjaFormAdmin = () => {
    // Only run on Ninja Forms admin pages
    if (!window.location.href.includes('page=ninja-forms')) {
        return;
    }

    // Use mutation observer to watch for input changes
    const observer = new MutationObserver((mutations) => {
        mutations.forEach(() => {
            const formychat_number = document.querySelector('input[type="text"]#formychat_number');
            if (!formychat_number) {
                return;
            }

            // If empty, show the formychat number
            if (formychat_number.value === '') {
                formychat_number.value = window.formychat_country_code;
            }
            
            // If the number is not empty, remove + from the number
            if (formychat_number.value !== '') {
                // observer.disconnect();
            }

            // Change placeholder
            formychat_number.placeholder = window.formychat_country_code;

            // Remove + from the number
            formychat_number.value = formychat_number.value.replace('+', '');
        });
    });

    // Observe the entire document for changes
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    // Check every second
    setInterval(() => {
        observer.takeRecords();
    }, 1000);

    
}
document.addEventListener('DOMContentLoaded', ninjaFormAdmin)